import { customTheme } from 'theme';

export const jitFormStyles = {
  /*emailIds: {
    label: {
      //color: customTheme.colors.gray['300'],
      fontWeight: 400,
    },
  },
  reactSelectField: {
    label: {
      //color: customTheme.colors.gray['300'],
      fontWeight: 400,
    },
  },
  textField: { label: { fontWeight: 400 } },
  customField: { label: { fontWeight: 400 } },*/
};
